module.exports = __webpack_public_path__ + "img/especialista_cemiterio_icone.cf9b42b6.png";